package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_11_15_Day_1
import com.veldekar.components.logs.Log_2025_11_15_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-11-15")
@Composable
public fun Log_2025_11_15(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Friends Of The Forest learn of The Bright Brothers",
        ogTitle = "The Friends Of The Forest learn of The Bright Brothers",
        date = LocalDate(2_025, 11, 15),
        aiHint = "Image and description are a joke. The Bright Brothers are actually a group of **human** adventurers.",
        ogDescription = "Brother Roberto Chandler, Brother Thradoris “Sly” Fox, and Brother Ignacio Cole",
        ogImage = "images/brightBrothers_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn illustration featuring three 'bright' characters: a candle-man, a lightbulb-fox, and a flame-man. This is a meme reference to the Bright Brothers which Lord Fox was a member of.",
    ) {
        SessionDayHeader(dayId = "shimmer-6", dateString = "Shimmer 6")
        Log_2025_11_15_Day_1()
        SessionDayHeader(dayId = "shimmer-7", dateString = "Shimmer 7")
        Log_2025_11_15_Day_2()
        SessionMediaItem(
            image = "images/brightBrothers.webp",
            linkImage = "images/brightBrothers.webp",
            description = "A hand-drawn illustration featuring three 'bright' characters: a candle-man, a lightbulb-fox, and a flame-man. This is a meme reference to the Bright Brothers which Lord Fox was a member of.",
            width = 3_435,
            height = 2_734,
        )
    }
}
